import { render } from "./ClassManage.vue?vue&type=template&id=935d5468&scoped=true"
import script from "./ClassManage.vue?vue&type=script&lang=js"
export * from "./ClassManage.vue?vue&type=script&lang=js"

import "./ClassManage.vue?vue&type=style&index=0&id=935d5468&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-935d5468"]])

export default __exports__